import Link from '../../atoms/Link/Link'
import DPGRecruitmentLogoIcon from '../../atoms/Logos/DpgRecruitmentLogo'
import analyticsAttributes from '../../../util/analytics-data-attributes/analyticsAttributes'
import { Action, Category } from '../../../util/analytics-data-attributes/analyticsAttributes'
import Nav from '../Nav/Nav'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import colors from '../../theme/colors'
import Breakpoints from '../../theme/breakpoints'
import { Job } from '../../../state/reducers/jobs/jobs'

const StyledNav = styled.nav`
  background-color: ${colors.Primary.Black};
  user-select: none;
  width: 280px;

  .logo {
    padding: 16px 0;
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  // Hide nav on server-side rendered pages 
  @media (max-width: ${Breakpoints.tablet}) {
    display: none;
  }
`

type Props = {
  className?: string
  isLoggedIn: boolean
  clickPlaceVacancyIsInProgress: boolean
  onClickPlaceVacancy: () => void
  itemsInCart?: number
  lastRejectedJob?: Job
}

const paths = {
  overzicht: {
    title: 'Overzicht',
    href: '/',
  },
}

const DesktopNav: React.FunctionComponent<Props> = ({
  className,
  isLoggedIn,
  clickPlaceVacancyIsInProgress,
  onClickPlaceVacancy,
  itemsInCart,
  lastRejectedJob,
}) => {
  const router = useRouter()

  return (
    <StyledNav className={className}>
      <Link
        className="logo"
        href={paths.overzicht.href}
        {...analyticsAttributes({
          router,
          action: Action.clickDashboard,
          category: Category.navigationMenuLeftbar,
          label: paths.overzicht.href,
        })}
      >
        <DPGRecruitmentLogoIcon />
      </Link>
      <Nav
        isLoggedIn={isLoggedIn}
        clickPlaceVacancyIsInProgress={clickPlaceVacancyIsInProgress}
        onClickPlaceVacancy={onClickPlaceVacancy}
        itemsInCart={itemsInCart}
        lastRejectedJob={lastRejectedJob}
      />
    </StyledNav>
  )
}

export default DesktopNav
